import { chatState } from "@/app/chatState";
import { EntryItem, useRefState, DateTimeRangeValue } from "@/components/UI/tools";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { appState } from "@/app/appState";

function withIntentLabel(base: string, intent?: string): string {
    const trimmed = intent?.trim();
    return trimmed ? `${base} - ${trimmed}` : base;
}

const ChatEventItem = observer(
    (params: { reload?: () => void; objKey: { type: "event"; id: number }, revision_id?: number, tool_id?: string, intent?: string }) => {
        const [loading, setLoading] = useState(false);
        const [refresh, setRefresh] = useState(0);

        const [title, setTitle] = useRefState<string>("");
        const [description, setDescription] = useRefState<string | undefined>("");
        const [location, setLocation] = useRefState<string | undefined>("");
        const [startTime, setStartTime] = useRefState<string>("");
        const [endTime, setEndTime] = useRefState<string>("");
        const [allDay, setAllDay] = useRefState<boolean>(false);
        const [tagName, setTagName] = useRefState<string>("");

        const identity = (edit: boolean | number | undefined) => { };
        const [ids, setIds] = useState<number[]>([]);
        const [id, setId] = useState<number>();

        useEffect(() => {
            const obj = chatState.chatObjects.get(params.objKey);

            if (!obj) {
                params.reload?.();
                return;
            }

            if (obj.type === "event" && obj.event) {
                let source: any = obj.event;
                if (params.revision_id && obj.event?.id && obj.revisions) {
                    const revisions_obj = [...obj.revisions].sort((a: any, b: any) => a.id - b.id).filter((x: any) => x?.id <= (params.revision_id ?? -1)).filter((x: any) => x ? true : false) ?? [];
                    const revObj = revisions_obj.filter((x: any) => x.id == params.revision_id)[0];
                    if (revObj) {
                        source = revObj;
                    }
                }

                setTitle(source.title ?? "");
                setDescription(source.description ?? "");
                setLocation(source.location ?? "");
                setStartTime(source.start_time ?? "");
                setEndTime(source.end_time ?? "");
                setAllDay(source.all_day ?? false);
                setTagName(source.tag_name ?? "");
                setId(obj.event.id);
            }

            setRefresh((p) => p + 1);
        }, [params.objKey, params.revision_id, chatState.chatObjects.get(params.objKey)]);

        const formatDateTime = (iso: string) => {
            if (!iso) return "";
            try {
                const d = new Date(iso);
                return d.toLocaleString(undefined, {
                    dateStyle: "medium",
                    timeStyle: "short",
                });
            } catch {
                return iso;
            }
        };

        return (
            <div
                id={`event${params.objKey.id}`}
                title={`event${params.objKey.id}`}
                className="h-full w-full"
            >
                <EntryItem
                    lock={false}
                    setEdit={() => { }}
                    headerClickNavigateFunction={(() => {
                        if (id) {
                            const i = chatState.chatObjects.get({ type: "event", id: id })?.revisions?.filter(x => x != undefined)?.findIndex((x: any) => x?.id == params.revision_id) != -1
                                ?
                                chatState.chatObjects.get({ type: "event", id: id })?.revisions?.filter(x => x != undefined)?.findIndex((x: any) => x?.id == params.revision_id)
                                :
                                undefined

                            return () => chatState.openObject({ type: "event", id }, i ?? -1);
                        }
                        return undefined
                    })()}
                    readonly={true}
                    name={withIntentLabel((!params.revision_id) ? appState.t("chat.tool.event") : appState.t("chat.tool.eventUpdate"), params.intent)}
                    chatForm={true}
                    loading={loading}
                    deleting={false}
                    refreshCount={refresh}
                    idParams={{
                        singular: { get: id, set: identity },
                        plural: { get: ids, set: setIds },
                    }}
                    nameColumn={{
                        type: "text",
                        value: title.current,
                        onChange: setTitle,
                        validator: (val: string) => val.length > 0,
                        label: appState.t("objects.title"),
                    }}
                    stateColumns={[
                        {
                            label: appState.t("objects.when"),
                            type: "datetimerange" as const,
                            onChange: () => { },
                            value: { startTime: startTime.current, endTime: endTime.current },
                            validator: () => true,
                            readonly: true,
                            allDay: allDay.current,
                        },
                    ]}
                />
            </div>
        );
    }
);

export default ChatEventItem;
